module.exports = __webpack_public_path__ + "img/134-21cf2f.png";